module.exports = __webpack_public_path__ + "img/995d3ec426161ca54162a06decb9f833.png";